import { securityQuestionsConstants } from "../_constants/securityQuestions.constant";

export default function securityQue(state = {}, action) {
  switch (action.type) {
    // security Questions list data
    case securityQuestionsConstants.GET_SECURITYQUESTIONS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case securityQuestionsConstants.GET_SECURITYQUESTIONS_LIST_SUCCESS:
      return {
        ...state,

        loading: false,
        getsecurityQuestionsList: action?.user,
      };
    case securityQuestionsConstants.GET_SECURITYQUESTIONS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

      //add que
      case securityQuestionsConstants.ADD_SECURITYQUESTIONS_LIST_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case securityQuestionsConstants.ADD_SECURITYQUESTIONS_LIST_SUCCESS:
        return {
          ...state,
  
          loading: false,
          addSecurityQuestionsList: action?.user,
        };
      case securityQuestionsConstants.ADD_SECURITYQUESTIONS_LIST_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.error,
        };

      
    // security Questions update
    case securityQuestionsConstants.UPDATE_SECURITYQUESTIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case securityQuestionsConstants.UPDATE_SECURITYQUESTIONS_SUCCESS:
      return {
        ...state,

        loading: false,
        error: action?.user,
      };
    case securityQuestionsConstants.UPDATE_SECURITYQUESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
      

      //Update security Questions status
      case securityQuestionsConstants.UPDATE_SECURITYQUESTIONSSTATUS_REQUEST:
        return {
            ...state,
            loading: true
        };
    case securityQuestionsConstants.UPDATE_SECURITYQUESTIONSSTATUS_SUCCESS:
        return {
            ...state,

            loading: false,

        };
    case securityQuestionsConstants.UPDATE_SECURITYQUESTIONSSTATUS_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error
        };

        //delete security Questions status
        case securityQuestionsConstants.DELETE_SECURITYQUESTIONS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case securityQuestionsConstants.DELETE_SECURITYQUESTIONS_SUCCESS:
            return {
                ...state,
    
                loading: false,
    
            };
        case securityQuestionsConstants.DELETE_SECURITYQUESTIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };

    default:
      return state;
  }
}
